import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { UzurvDirectivesModule } from '@uzurv/core';
import { UzurvPipesModule } from '@uzurv/core';
import { RiderFareCollectionDialogComponent } from './rider-fare-collection-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    UzurvDirectivesModule,
    UzurvPipesModule],
  exports: [RiderFareCollectionDialogComponent],
  declarations: [RiderFareCollectionDialogComponent]
})
export class RiderFareCollectionDialogModule {}
